import { deepMenu, FocusWithin, State } from './Component/Menu';

import './Main.scss';

FocusWithin(document);

new State({
    header: '.header',
    namespace: 'header-nav'
});

new deepMenu({
    namespace: 'deep-nav',
    header: 'header',
    hamburger: 'header__hamburger'
});

